import { render, staticRenderFns } from "./ReservationScheduleSettingTable.vue?vue&type=template&id=54b5a0d1&scoped=true&lang=pug"
import script from "./ReservationScheduleSettingTable.vue?vue&type=script&lang=ts"
export * from "./ReservationScheduleSettingTable.vue?vue&type=script&lang=ts"
import style0 from "./ReservationScheduleSettingTable.vue?vue&type=style&index=0&id=54b5a0d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b5a0d1",
  null
  
)

export default component.exports